export default __webpack_public_path__ + "static/media/Bitmap_9.f409c686.jpg";